<!-- <mat-grid-list [cols]="currCols" [rowHeight]="rowHeight" gutterSize="20px" *ngIf="clientAddresses$">

    <mat-grid-tile class="address-card add-card clicked" (click)="openDialAddress()" angulartics2On="click" angularticsAction="openCreateDialog" angularticsCategory="addresses">

        <div fxLayout="column" fxLayoutAlign="center center" class="full-screen text-center">
            <span class="mat-subheading-1">Ajouter une adresse</span>
        </div>

    </mat-grid-tile>

    <mat-grid-tile *ngFor="let add of clientAddresses$" class="address-card clicked" [class.isSelected]="delivryAddress$ && delivryAddress$.address_id === add.address_id || billingAddress$ && billingAddress$.address_id === add.address_id">

        <div fxLayout="column" class="layout-padd-4 full-screen">

            <div fxLayout="column" class="fill-rest" id="inf-add" (click)="selectAddress(add)">

                <div fxLayout="row" fxLayoutAlign="space-between center">

                    <span class="mat-subheading-1 boldest">{{add.name}}</span>

                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">

                        <div *ngIf="add.is_default === 1 && !type" fxLayoutAlign="center center" style="height: 25px; padding: 0 5px;" [ngStyle.xs]="{'height.px': 20}" class="great rad-bord">
                            <span class="mat-subheading-1 boldest">DEFAUT</span>
                        </div>

                        <i class="fas fa-user dark-ico" style="font-size:1.5em;" *ngIf="add.professional === 0"></i>
                        <i class="fas fa-building dark-ico" style="font-size:1.5em;" *ngIf="add.professional === 1"></i>

                        <img src="data:image/png;base64,{{add.country_flag}}" class="logo-card">

                    </div>

                </div>

                <div fxLayout="column" fxLayoutAlign="center center" class="fill-rest">

                    <div class="full-w">
                        <span class="mat-subheading-1">{{add.address | descFilter: 60}}</span>
                    </div>

                    <div class="full-w" fxLayout="row" fxLayoutGap="10px">

                        <div>
                            <span class="mat-subheading-1">{{add.city_name | uppercase}}</span>
                        </div>

                        <div>
                            <span class="mat-subheading-1">-</span>
                        </div>

                        <div>
                            <span class="mat-subheading-1">{{add.postal}}</span>
                        </div>

                    </div>

                    <div class="full-w">
                        <span class="mat-caption" style="font-style: italic;">{{add.comment}}</span>
                    </div>

                </div>

            </div>

            <div fxLayout="row" fxLayoutAlign="space-between">
                <span class="mat-caption great-ico boldest" (click)="openDialAddress(add)" angulartics2On="click" angularticsAction="openUpdateDialog" angularticsCategory="addresses">Modifier</span>
                <span class="mat-caption warn-ico boldest" (click)="openDialDeletAddress(add.address_id)" angulartics2On="click" angularticsAction="openDeleteDialog" angularticsCategory="addresses">Supprimer</span>
            </div>

        </div>

    </mat-grid-tile>

</mat-grid-list> -->
<mat-list></mat-list>
<mat-list *ngIf="clientAddresses$">

    <mat-list-item *ngFor="let add of clientAddresses$" class="rad-bord clicked address-card-height" [class.isSelected]="delivryAddress$ && delivryAddress$.address_id === add.address_id || billingAddress$ && billingAddress$.address_id === add.address_id"
        (click)="selectAddress(add)">

        <!-- <mat-icon  fxHide.xs mat-list-icon class="great-ico" *ngIf="delivryAddress$ && delivryAddress$.address_id === add.address_id || billingAddress$ && billingAddress$.address_id === add.address_id">done</mat-icon> -->

        <div mat-line>

            <div fxLayout="column">

                <div fxLayout="row" fxLayoutAlign="start center"> <span class="mat-subheading-1 boldest">{{add.name}}</span></div>

                <div fxLayout="row" fxLayoutGap="10px">

                    <div>
                        <span class="mat-subheading-1">{{add.address | descFilter: 60}}</span>
                    </div>

                    <div fxHide.xs>
                        <span class="mat-subheading-1">{{add.city_name | uppercase}}</span>
                    </div>

                    <div fxHide.xs>
                        <span class="mat-subheading-1">-</span>
                    </div>

                    <div fxHide.xs>
                        <span class="mat-subheading-1">{{add.postal}}</span>
                    </div>

                </div>

                <div fxLayout="row">
                    <div *ngIf="add.comment" fxLayoutAlign="start center">
                        <span class="mat-caption" style="font-style: italic;">{{add.comment}}</span>
                    </div>
                </div>

            </div>

        </div>

        <mat-icon mat-icon-button class="great-ico" (click)="openDialAddress(add); $event.stopPropagation();" angulartics2On="click" angularticsAction="openUpdateDialog" angularticsCategory="addresses">edite</mat-icon>
        <mat-icon mat-icon-button class="warn-ico" (click)="openDialDeletAddress(add.address_id); $event.stopPropagation();" angulartics2On="click" angularticsAction="openDeleteDialog" angularticsCategory="addresses">delete</mat-icon>

    </mat-list-item>

    <mat-list-item class="clicked" [class.divider-top]="clientAddresses$.length > 0" [ngStyle]="{'margin-top' : clientAddresses$.length > 0 ? '10px' : '0px'}" (click)="openDialAddress()" angulartics2On="click" angularticsAction="openCreateDialog" angularticsCategory="paymentMethods">

        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">

            <div fxLayout="row" fxLayout="start center" fxLayoutGap="5px">
                <div fxLayoutAlign="start center">
                    <span class="mat-subheading-1">{{'AddressAllincComponent.addaddress'|translate}}</span>
                </div>
            </div>

            <mat-icon class="great-ico">add</mat-icon>
        </div>

    </mat-list-item>

</mat-list>

<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="'AddressAllincComponent.loader'|translate" [type]="'line'">
</app-popup-loader>